"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: 10
    }
});
//# sourceMappingURL=controlPanel.style.js.map